const PAGE_VARIANTS = {
  personal: { width: 'wide', density: 'ordinary' },
  discovery: { width: 'wide', density: 'ordinary' },
  configuration: { width: 'standard', density: 'ordinary' },
  workspace: { width: 'standard', density: 'ordinary' },
  operational: { width: 'fluid', density: 'operational' },
};

const WIDTHS = new Set(['reading', 'standard', 'wide', 'fluid']);
const DENSITIES = new Set(['ordinary', 'operational']);

export default function ApplicationPage({
  variant = 'personal',
  width,
  density,
  ariaLabelledby,
  className = '',
  children,
}) {
  const defaults = PAGE_VARIANTS[variant];

  if (!defaults) {
    throw new Error(`Unsupported ApplicationPage variant: ${variant}`);
  }

  const resolvedWidth = width || defaults.width;
  const resolvedDensity = density || defaults.density;

  if (!WIDTHS.has(resolvedWidth)) {
    throw new Error(`Unsupported ApplicationPage width: ${resolvedWidth}`);
  }

  if (!DENSITIES.has(resolvedDensity)) {
    throw new Error(
      `Unsupported ApplicationPage density: ${resolvedDensity}`
    );
  }

  const classes = [
    'av-app-page',
    `av-app-page--${variant}`,
    `av-app-page--width-${resolvedWidth}`,
    `av-app-page--density-${resolvedDensity}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      aria-labelledby={ariaLabelledby}
      className={classes}
      data-av-app-density={resolvedDensity}
      data-av-app-page={variant}
      data-av-app-width={resolvedWidth}
    >
      <div className="av-app-page__inner">
        {children}
      </div>
    </div>
  );
}
